/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
        
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
        
        
export default function Barn(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/models/barn.gltf')
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh geometry={nodes.Barn_001.geometry} material={materials.None} />
    </group>
  )
}

useGLTF.preload('/models/barn.gltf')